module.exports = "/_next/static/images/6f5cec0f0d22c9863bff2e5981c4660b-old-insurances.jpg.webp";